import axios from 'axios';

export function postCommentForm(postUrl, data={}) {
  return axios.post(postUrl, data);
}